module.exports = __webpack_public_path__ + "static/media/G_PAY.90e2ad9a.png";